import styled from "styled-components";

import { LabelText } from "../styles";

export const StyledCheckbox = styled.div`
  width: fit-content;
  margin-bottom: 22px;
  ${(props) =>
    props.isDisabled &&
    `
    opacity: .5;
    pointer-events: none;
    cursor:
  `}
`;

export const CheckboxOptionList = styled.div`
  width: 100%;
  display: flex;
  flex-direction: ${({ orientation }) =>
    orientation === "vertical" ? "column" : "row"};
  gap: 10px;
  margin-top: 10px;
`;

export const CheckboxInput = styled.input`
  height: ${({ variant }) => (variant === "large" ? "20px" : "16px")};
  width: ${({ variant }) => (variant === "large" ? "20px" : "16px")};
  // The UA's default 3px vertical margin made the label taller than the
  // painted box, leaving the box 3px above the label text.
  margin-block: 0;
  margin-right: 8px;
  opacity: 0;
`;

export const CheckboxInputLabel = styled.label`
  font-size: 12px;
  font-family: "Inter";
  display: flex;
  align-items: center;
  position: relative;
  color: var(--checkbox-label-color);
  line-height: 12px;

  .unchecked {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    height: ${({ variant }) => (variant === "large" ? "20px" : "16px")};
    width: ${({ variant }) => (variant === "large" ? "20px" : "16px")};
    background-color: var(--checkbox-unchecked-bg);
    border: ${({ focused }) =>
      focused
        ? "1px solid var(--checkbox-unchecked-border-focus)"
        : "1px solid var(--checkbox-unchecked-border)"};
    border-radius: 4px;
  }

  .checked {
    box-sizing: border-box;
    position: absolute;
    top: 0;
    left: 0;
    height: ${({ variant }) => (variant === "large" ? "20px" : "16px")};
    width: ${({ variant }) => (variant === "large" ? "20px" : "16px")};
    background-color: #fff;
    border: none;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ isDisabled, focused, style }) =>
      isDisabled
        ? "var(--checkbox-checked-bg-disabled)"
        : focused
        ? "var(--checkbox-checked-bg-focus)"
        : style?.iconBackgroundColor
        ? style?.iconBackgroundColor
        : "var(--checkbox-checked-bg)"};
  }

  .explicit {
    display: flex;
    justify-content: center;
    align-items: center;
    background: ${({ isDisabled }) =>
      isDisabled
        ? "var(--checkbox-checked-bg-disabled)"
        : "var(--checkbox-explicit-false-bg)"};
  }

  &:hover {
    cursor: pointer;
  }
`;

export const CheckboxGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
  column-gap: 25px;
  row-gap: 10px;
  margin-top: 10px;
  margin-bottom: 20px;
`;

export const CheckboxGroupItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const LabelTextWithIcon = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

// CheckboxGroup owns the container/label/skeleton chrome it had in Form/styles,
// so the shared Field styles stay untouched by this component.
export const CheckboxGroupContainer = styled.div`
  width: 100%;

  ${(props) =>
    props.disabled &&
    `
    opacity: .5;
    pointer-events: none;
  `}
`;

export const CheckboxGroupLabel = styled(LabelText)`
  margin-bottom: 3px;
`;

export const CheckboxSkeletonContainer = styled.div`
  height: 41px;
  border-radius: 4px;
  border: 1px solid #dddbda;
  padding: 10px 8px;
  background-color: #ffffff;
  margin-bottom: 22px;

  span {
    border-radius: 2px;
    height: 100%;
    display: flex;
  }
`;
